export const getMapperDisplaySerialNumberText = (serialNumber) => serialNumber === '' ? '' : `...${serialNumber.slice(-3)}`;
